export default __webpack_public_path__ + "static/media/graph-icon.24c537e1.svg";